/*!
* @Author: jinbin
* @Date: 2022-11-25 11:53:00
* @Last Modified by: jinbin
* @Last Modified time: 2022-11-25 11:53:00
* @Instruduction: 中间件处理器(目前仅支持同步)
*/

class AppMiddleware {
    constructor() {
        this.middleware = []
    }

    /**
     * 注册中间件
     * @date 2022-11-25
     * @param {(ctx, callback)} fn
     * @returns {any}
     */
    use(fn) {
        if (typeof fn !== 'function') {
            throw new Error('middleware use: expect a function')
        }
        this.middleware.push(fn)
    }

    /**
     * 归并中间件
     * @date 2022-11-25
     * @returns {any}
     */
    compose() {
        return this.middleware.reduce((a, b) => (ctx, next) => a(ctx, () => b(ctx, next)))
    }
}

export default new AppMiddleware()
